<div class="fadeIn">
    <div class="form-container">
        <div class="form-card">
            <BR>
            <h2 style="text-align: center;" class="titulo">CAMBIO DE CONTRASEÑA</h2>
            <BR>


            <form (ngSubmit)="actualizarPassword(f,correo,usuario.password); f.resetForm()" #f="ngForm">

                <!-- Email -->
                <label>Correo electrónico</label>
                <small *ngIf="email.invalid && email.touched" class="form-text text-danger animated fadeIn">
          Escriba un email válido
        </small>
                <input [(ngModel)]="correo" type="email" name="email" [disabled]="!bandera" required email ngModel #email="ngModel" class="input100" placeholder="correo@correo.com" />
                <BR>

                <!-- Password -->
                <label>Nueva contraseña</label>
                <small *ngIf="password.invalid && password.touched" class="form-text text-danger animated fadeIn">
          Al menos 3 caracteres
        </small>
                <input [(ngModel)]="usuario.password" type="password" name="password" required minlength="3" ngModel #password="ngModel" class="input100" placeholder="Nueva contraseña" />
                <BR>
                <BR>

                <button type="submit" class="submit-btn">Actualizar contraseña</button>

            </form>

        </div>
    </div>
</div>